
function onClickClassTab(el, type) {
    console.log('onClickClassTab', el, type);

    // Handle tab active state
    const tabs = document.getElementsByClassName('class-tab');
    Array.from(tabs).forEach((element) => {
        element.classList.remove('active');
    });
    el.classList.add('active');

    // Handle content visibility
    const contents = document.getElementsByClassName('desc-content');
    Array.from(contents).forEach((content) => {
        content.classList.remove('active');
    });

    if (type === 'desc') {
        contents[0].classList.add('active');
    } else if (type === 'tnc') {
        contents[1].classList.add('active');
    } else if (type === 'instructor') {
        contents[2].classList.add('active');
    }
}


